import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fmtMoney, fmtDate } from "@/lib/api";
import { ArrowLeft } from "@phosphor-icons/react";

export default function BrokerDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [ledger, setLedger] = useState(null);

  useEffect(() => {
    api.get(`/brokers/${id}`).then((r) => setData(r.data));
    api.get(`/brokers/${id}/ledger`).then((r) => setLedger(r.data)).catch(() => {});
  }, [id]);

  if (!data) return <div className="label-mini">Loading…</div>;

  return (
    <div className="space-y-6" data-testid="broker-detail-page">
      <Link to="/brokers" className="text-xs label-mini flex items-center gap-1 hover:text-black">
        <ArrowLeft size={12} /> Back to Brokers
      </Link>
      <div className="card-sharp p-6 grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 flex-wrap">
            <h1 className="text-3xl font-bold tracking-tight">{data.name}</h1>
            <span className="font-mono text-xs text-zinc-500">{data.code}</span>
            <span className="status-badge" style={{ background: data.status === "active" ? "#D1FAE5" : "#F4F4F5", color: data.status === "active" ? "#065F46" : "#52525B", borderColor: data.status === "active" ? "#10B981" : "#E4E4E7" }}>{data.status}</span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-5">
            <Info label="Contact" value={data.contact_person} />
            <Info label={data.contact_channel || "Channel"} value={data.contact_value} />
            <Info label="Email" value={data.email} />
            <Info label="Commission" value={`${data.commission_pct || 0}%`} />
          </div>
        </div>
        <div className="card-sharp p-4 bg-zinc-50 border-zinc-200">
          <div className="label-mini">Holding of Ours</div>
          <div className="kpi-num text-3xl mt-2 tnum" data-testid="broker-balance">{fmtMoney(data.balance || 0)}</div>
          <div className="text-[11px] text-zinc-500 mt-1">Positive = broker is holding this cash for us</div>
        </div>
      </div>

      {ledger && (
        <div className="card-sharp p-5">
          <h3 className="text-lg font-semibold tracking-tight mb-3">Ledger</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left label-mini border-b border-zinc-200">
                  <th className="py-2">Date</th>
                  <th className="py-2">Description</th>
                  <th className="py-2 text-right">Advance (PKR)</th>
                  <th className="py-2 text-right">Used (PKR)</th>
                  <th className="py-2 text-right">Holding</th>
                </tr>
              </thead>
              <tbody>
                {ledger.transactions.map((t) => (
                  <tr key={t.id} className="border-b border-zinc-100">
                    <td className="py-2 text-xs font-mono">{fmtDate(t.date)}</td>
                    <td className="py-2 text-xs">{t.description}</td>
                    <td className="py-2 text-right font-mono tnum">{t.txn_type === "debit" ? fmtMoney(t.amount, "") : "—"}</td>
                    <td className="py-2 text-right font-mono tnum">{t.txn_type === "credit" ? fmtMoney(t.amount, "") : "—"}</td>
                    <td className="py-2 text-right font-mono tnum font-semibold">{fmtMoney(t.balance_after, "")}</td>
                  </tr>
                ))}
                {ledger.transactions.length === 0 && (
                  <tr><td colSpan={5} className="py-6 text-center text-xs text-zinc-500">No transactions yet.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

const Info = ({ label, value }) => (
  <div>
    <div className="label-mini">{label}</div>
    <div className="text-sm font-medium">{value || "—"}</div>
  </div>
);
